import { INewbuilding } from '../../types/newbuilding';

export function isNewbuildingInLeadFactory(newbuilding: INewbuilding): boolean {
  if (!Array.isArray(newbuilding.sellers)) {
    return false;
  }

  return newbuilding.sellers.some(seller => seller.isLeadFactory);
}
